import React from 'react'

const Context = React.createContext({ isFullScreen: false })
const { Provider } = Context
export const useFullScreenState = () => React.useContext(Context)

export const useFullScreenToggler = () => {
  const { isFullScreen, setFullScreen } = useFullScreenState()

  return () => {
    const elem = document.getElementById('fullScreenContent')
    setFullScreen(!isFullScreen)

    if (!isFullScreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen()
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen()
      }
    }
  }
}

const FullScreenContext = props => {
  const [isFullScreen, setFullScreen] = React.useState(false)

  return <Provider value={{ isFullScreen, setFullScreen }} {...props} />
}

export default FullScreenContext
